import { isArray, isBoolean, isString } from 'lodash';

const sportHomePages = {
    'horse-racing': 'meetings',
    greyhounds: 'meetings',
    'in-play': 'inPlay',
    homepage: 'home',
    default: 'highlights',
};

const customMarkets = {
    OB_TY295: [
        {
            id: 'OB_MG40706',
            title: 'Premier League Relegation Odds',
        },
        {
            id: 'OB_MG7802',
            title: 'Premier League Winner Odds',
        },
        {
            id: 'OB_MG414592',
            title: 'Premier League Top 4 Betting',
        },
    ],
    OB_TY22740: [
        {
            id: 'OB_MG13825818',
            title: 'Premier League Transfer Betting',
        },
    ],
    OB_TY344: [
        {
            id: 'OB_MGMB',
            title: 'Champions League Betting',
        },
    ],
};

const isShownOnAllPages = (showOnAllPages) => (isArray(showOnAllPages) && showOnAllPages.length)
    || (isBoolean(showOnAllPages) && showOnAllPages);

export const isSportHomePage = (sportEn, page) => {
    const homePage = sportHomePages[sportEn] || sportHomePages.default;
    return homePage === page;
};

export const checkSeoBoxDataExistence = (data) => data && data.bottom_h2;

export const filterSubfeatures = (subfeatures, sportEn, customId, marketId) => subfeatures.filter((subFeature) => {
    if (isShownOnAllPages(subFeature.showOnAllPages)) {
        return subFeature;
    }

    const customTitle = customMarkets[customId]?.find((market) => market.id === marketId)?.title;

    if (customTitle) return subFeature.sectionTitle.startsWith(customTitle);

    if (customId === 'OB_TY295') {
        return subFeature.sectionTitle.startsWith('Premier League betting');
    }

    if (subFeature.selectSports && isString(subFeature.selectSports[0])) {
        return subFeature.selectSports.includes(sportEn);
    }

    return (
        subFeature.selectSports
            && subFeature.selectSports.some((sports) => sports.label === sportEn)
    );
});
